import { render, staticRenderFns } from "./DeliveryAddressInput.vue?vue&type=template&id=6837bff4&scoped=true&lang=pug&"
import script from "./DeliveryAddressInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressInput.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressInput.vue?vue&type=style&index=0&id=6837bff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837bff4",
  null
  
)

export default component.exports